import '~/css/shared/navbar.css';
import '@/shared/navbar-v1/navbar-search';
import '@/shared/navbar-v1/navbar-notifications';
import '@/shared/navbar-v1/navbar-messages';
import '@/shared/navbar-v1/services-dropdown-menu-legacy';
import '@/shared/3d-models/navbar-dropdown';
import "bootstrap/js/src/collapse";
import "bootstrap/js/src/dropdown";

import $ from 'jquery';

import eventBus from "@/shared/event-bus";

var $navbar = $('.navbar');

$navbar.on('show.bs.collapse', function () {
    var actives = $(this).find('.collapse.show');
    var hasData;

    if (actives && actives.length) {
        hasData = actives.data('bs.collapse');
        if (hasData) {
            return actives.collapse('hide');
        }
        hasData || actives.data('bs.collapse', null);
    }
});

/*
$navbar.on('hide.bs.collapse', function (e) {
    $(e.target).data('bs.collapse').$trigger.blur();
});
*/

eventBus.on('user-balance-changed', (e) => {
    $navbar.find('.balance').text(e.balance.formatCurrency());
});
